import { IconProps } from "../../utils/global-types/global-types";

const ReplyIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-[18px] h-[18px]"}
    {...rest}
  >
    <g clipPath="url(#clip0_787_65192)">
      <path
        fill="currentColor"
        d="M7.815 6.189V3.956a.395.395 0 0 0-.668-.282L2.685 8.005a.39.39 0 0 0 0 .565l4.462 4.331a.395.395 0 0 0 .668-.282v-2.231h.744a6.7 6.7 0 0 1 5.856 3.45l.01.02a.394.394 0 0 0 .74-.19c0-4.08-3.285-7.409-7.35-7.48"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_787_65192">
        <path fill="#fff" d="M2.565 2.565h12.6v12.6h-12.6z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default ReplyIcon;
